module.exports = __webpack_public_path__ + "img/pattern_01.5c8ce033.jpg";